import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-neutral-800 text-white">
      <div className="container-app py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary-500 rounded-xl flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="font-heading font-bold text-xl">Gadaye</span>
                <span className="font-heading text-sm text-primary-400 block -mt-1">Appartement</span>
              </div>
            </div>
            <p className="text-neutral-400 mb-4 max-w-md">
              Votre plateforme de confiance pour la location d'appartements meublés. 
              Trouvez le logement idéal pour vos séjours au Sénégal.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-neutral-400 hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-neutral-400 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/apartments" className="text-neutral-400 hover:text-white transition-colors">
                  Appartements
                </Link>
              </li>
              <li>
                <Link to="/register?role=ROLE_GERANT" className="text-neutral-400 hover:text-white transition-colors">
                  Devenir gérant
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-neutral-400 hover:text-white transition-colors">
                  Connexion
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-neutral-400">
                <MapPin className="w-4 h-4 mr-2 flex-shrink-0" />
                <span>Dakar, Sénégal</span>
              </li>
              <li className="flex items-center text-neutral-400">
                <Phone className="w-4 h-4 mr-2 flex-shrink-0" />
                <span>+221 77 123 45 67</span>
              </li>
              <li className="flex items-center text-neutral-400">
                <Mail className="w-4 h-4 mr-2 flex-shrink-0" />
                <span>contact@gadaye.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-neutral-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-neutral-400 text-sm">
            © {new Date().getFullYear()} Gadaye Appartement. Tous droits réservés.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
              Mentions légales
            </Link>
            <Link to="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
              Confidentialité
            </Link>
            <Link to="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
              CGU
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
